<template>
<SiteHeader></SiteHeader>
<SiteProgress></SiteProgress>
<div style="text-align: center;min-height: 600px;">
    <div class="container small" style="background-color: #212020;" v-if="isBderror">
    <div class="metaportal_fn_mint_top row pad50">
      <h1>OOpss!</h1>
      <h4>Your booking has been failed</h4>
    </div>
  </div>
<img src="@/../public/assets/img/error.png" style="width: 26%;padding-top: 40px;" alt="Image" class="ggg"><br>
   
</div>
<SiteFooter></SiteFooter>
</template>
<script>

import SiteHeader from './SiteHeader.vue';
import SiteFooter from '../UI/SiteFooter.vue';
import SiteProgress from '../UI/SiteProgress.vue';
export default {
    data() {
        return {
            imgPath: process.env.BASE_URL,
        }
    },
    components:{
       
        SiteHeader,
   SiteFooter,
        SiteProgress
// 
    }
}
</script>
<style scoped>
.ggg{
    width: 45%;
height: auto;
}
</style>